import { ButtonHTMLAttributes, forwardRef } from 'react';
import { ButtonProps, ButtonVariant, ButtonSize } from "./types";
import Spiner from "../loading/Spiner";
import { Link } from "react-router-dom";

const Button = forwardRef<HTMLButtonElement, ButtonHTMLAttributes<HTMLButtonElement> & ButtonProps>((props, ref) => {
  const {
    startIcon = undefined,
    endIcon = undefined,
    size = 'base',
    variant = 'default',
    label,
    onClick,
    type = 'button',
    as = undefined,
    disabled = false,
    loading = false,
    children,
    className = '',
    href = "",
    target = "_self",
    ...restProps
  } = props;

  const ring = "hover:ring-1 focus:ring-2 active:ring-1 hover:ring-primary focus:ring-primary active:ring-primary";

  // Define class names for each button variant
  const variants: Record<ButtonVariant, string> = {
    default: `text-white bg-blackBase hover:bg-primary focus:bg-primary active:bg-primary ring-1 ring-blackBase ${ring}`,
    contained: `text-white bg-blackBase hover:bg-primary focus:bg-primary active:bg-primary ring-1 ring-blackBase ${ring}`,
    outlined: `text-blackBase bg-white hover:text-primary focus:text-primary active:text-primary ring-1 ring-blackBase ${ring}`,
    transparent: `text-blackBase bg-transparent hover:text-primary focus:text-primary active:text-primary ring-0 ${ring}`,
  };

  const sizes: Record<ButtonSize, string> = {
    sm: 'px-2 py-1 text-xs',
    wide: 'px-4 py-1 text-sm',
    base: 'px-4 py-[5px] text-base h-[36px]',
    md: 'px-4 py-1 text-base',
    lg: 'px-5 py-2 text-lg h-[40px]',
  }

  const classes = `disabled:cursor-not-allowed disabled:ring-0 disabled:text-graySoft disabled:bg-gray-300 flex flex-row justify-center items-center items-center gap-3 focus:outline-none font-medium duration-300 rounded-md ${variants[variant]} ${sizes[size]} ${className}`;

  const start = loading ?
    <Spiner className='!h-5' classSvg='!w-5 !h-5' />
    : startIcon

  // @ts-ignore:next-line
  if (as === 'link') {
    return (
      <Link
        className={`${disabled || loading ? "pointer-events-none cursor-not-allowed" : "pointer-events-auto"} ${classes}`}
        to={href}
        onClick={onClick}
        target={target}
      >
        {start}
        {label || children}
        {endIcon}
      </Link>
    )
  }

  return (
    <button
      type={type}
      disabled={disabled || loading}
      className={classes}
      onClick={onClick}
      ref={ref}
      {...restProps}
    >
      {start}
      {label || children}
      {endIcon}
    </button>
  );
});

export default Button;
